<template>
  <section>
    <page-header :page="page">
      <template #custom_actions>
        <ActionButton
          text="Regresar"
          class="mr-3"
          variant="outline-success"
          i="fas fa-arrow-circle-left"
          @click="$router.go(-1)"
        />
        <ActionButton
          v-if="canBeSubmitted"
          variant="success"
          class="mr-3"
          text="Someter"
          i="fas fa-flag-alt"
          @click="submitCertification"
        />
        <ActionButton
          v-if="!IsReadonly && isPrivateSchool"
          variant="outline-success"
          text="Añadir Estudiante"
          i="fas fa-user-plus"
          @click="addStudent"
        />
      </template>
    </page-header>

    <section-title
      icon="fas fa-file-alt"
      content="Información de Certificación"
      container-class="tag-badge-main-info m-0 mb-3"
    />

    <board class="mb-3" :details="dashboard" />

    <board class="mb-3" :bg-white="false" :details="location" />

    <div class="row mb-3">
      <div class="col-12">
        <custom-separator
          :options="separatorFilter.options"
          @selected="onStudentFilterChanged($event)"
        />
      </div>
    </div>

    <div
      v-if="studentInfoManual.visible"
      class="bg-gray py-2 px-1 mb-3 student-info-container"
    >
      <ValidationObserver ref="searchStudentRef">
        <form novalidate @submit.prevent>
          <div>
            <div class="mx-1 p-3 bg-white" style="border-radius: 5px;">
              <div class="row">
                <div class="col-md-5 col-sm-12">
                  <em
                    class="fas fa-user-plus rounded-circle shadow text-orange p-2 mr-2"
                  />
                  <span class="student-info-container__box-main-title">
                    Añadir Estudiante
                  </span>
                </div>
                <div class="col-md-7 col-sm-12">
                  <div
                    v-if="
                      studentInfoManual.data &&
                        studentInfoManual.isValid === true
                    "
                    class="w-balloon"
                  >
                    <custom-balloon
                      color="text-white"
                      bg="bg-gray--2"
                      text="Resultado"
                    />
                  </div>
                </div>
              </div>
              <div class="row mt-3">
                <div class="col-md-5">
                  <ValidationProvider
                    v-slot="{ errors }"
                    name="Fecha"
                    rules="required"
                  >
                    <custom-input
                      v-model="studentInfoManual.studentSie"
                      placeholder="Escribir Número de SIE o Registro"
                      class="w-90"
                      :error="errors[0]"
                      custom-error-msg="Campo requerido."
                    />
                  </ValidationProvider>
                </div>
                <div class="col-md-7">
                  <div class="row py-2">
                    <div
                      v-if="studentInfoManual.data"
                      class="col-md-6 col-sm-12 border-left px-5"
                    >
                      <div class="row mt-n1">
                        <span
                          class="font-weight-normal  mr-1 student-info-container__field-label"
                        >
                          Nombre:
                        </span>
                        <span class="student-info-container__field-value">
                          {{ studentInfoManual.data.fullName }}
                        </span>
                      </div>
                      <div class="row">
                        <span
                          class="font-weight-normal mr-1 student-info-container__field-label"
                        >
                          Edad:
                        </span>
                        <span class="student-info-container__field-value">
                          {{ studentInfoManual.data.age }}
                        </span>
                      </div>
                      <div class="row">
                        <span
                          class="font-weight-normal mr-1 student-info-container__field-label"
                        >
                          SIE:
                        </span>
                        <span class="student-info-container__field-value">
                          {{ studentInfoManual.data.studentId }}
                        </span>
                      </div>
                      <div class="row">
                        <span
                          class="font-weight-normal mr-1 student-info-container__field-label"
                        >
                          Registro:
                        </span>
                        <span class="student-info-container__field-value">
                          {{ studentInfoManual.data.regNumber }}
                        </span>
                      </div>
                    </div>
                    <div v-else class="col-md-6 col-sm-12 border-left px-2">
                      <div class="w-70 text-center color-gray--3">
                        <span v-if="false" class="">
                          No se encontró Número de SIE en sistema
                        </span>
                      </div>
                    </div>
                    <div class="col-md-6 col-sm-12">
                      <div
                        class="d-flex align-items-end justify-content-end mr-4 actions-add h-100"
                      >
                        <div>
                          <action-button
                            class="mr-3"
                            text="Cancelar"
                            variant="outline-danger"
                            i="fas fa-times-circle"
                            @click="cancelAddStudent"
                          />
                          <action-button
                            v-if="!studentInfoManual.data"
                            type="submit"
                            class="px-4"
                            variant="success"
                            text="Buscar"
                            @click="searchAddStudent"
                          />
                          <action-button
                            v-else
                            class="px-4"
                            variant="success"
                            text="Añadir"
                            @click="addManualStudent"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </ValidationObserver>
    </div>

    <div class="mb-3">
      <filter-manager :filters="filtersHeader" @search="fastSearch" />
    </div>
    <div
      v-for="(grouped, custodianUserFullName) in custodianGroup"
      :key="custodianUserFullName"
    >
      <div
        v-if="showStudentHeader && searchMode != 2"
        class="bg-gray--4 mb-3 board-radius--4px p-3 mt-3"
      >
        <div class="row">
          <div class="col-md-10 col-sm-6">
            <div class="d-flex">
              <div class="mt-2 d-inline">
                <em
                  class="fas fa-user-circle rounded-circle shadow text-orange p-1 font-28 mr-2"
                />
              </div>
              <div>
                <span class="body-2 text-gray">Custodio:</span>
                <p class="body-1">
                  {{ custodianUserFullName }}
                </p>
              </div>
            </div>
          </div>

          <div class="col-md-2 col-sm-6">
            <span class="body-2 text-gray">Cantidad de Estudiantes:</span>
            <p class="body-1 ml-6">
              {{ grouped.length }}
            </p>
          </div>
        </div>
      </div>
      <div
        v-for="detail in grouped"
        :key="detail.childCountCertificationStudentId"
      >
        <custom-callout
          class="mt-3 text-normal"
          :show-edition="detail.showEdit"
          :show-bottom-section="searchMode == 2"
          :border-color="getColor(detail.studentStatusCode)"
        >
          <div class="bg-gray">
            <div class="row">
              <div class="col-md-6 col-xs">
                <p class="body-2 text-gray m-0">
                  Estudiante:
                  <span v-if="detail.isManualAddFlag" class="text-green">
                    <em class="fal fa-info-circle ml-1" />
                    &nbsp;&nbsp;Añadido manualmente
                  </span>
                </p>
                <p class="body-1 m-0">
                  {{ detail.studentName }}
                </p>
                <p class="font-weight-normal font-italic">
                  {{ detail.studentSieId }}
                </p>
              </div>
              <div class="col-md-2 col-xs">
                <span class="body-2 text-gray">Registro:</span>
                <p class="body-1 font-weight-normal">
                  {{ detail.regStudentId }}
                </p>
              </div>
              <div class="col-md-2 col-xs">
                <span class="body-2 text-gray">Estatus Estudiante:</span>
                <div class="w-balloon-status">
                  <custom-balloon
                    :icon="
                      `fas fa-circle ${getColor(detail.studentStatusCode)}`
                    "
                    :withBorder=false
                    :text="detail.studentStatusName"
                  />
                </div>
              </div>
              <div class="col-md-2 col-xs">
                <span class="body-2 text-gray">Edad:</span>
                <p class="body-1 font-weight-normal">
                  {{ detail.age }}
                </p>
              </div>
              <div v-if="!IsReadonly" class="col-md-2 col-xs mb-4">
                <div class="mt-4">
                  <action-button
                    v-if="detail.isManualAddFlag"
                    i="fas fa-minus-circle"
                    variant="outline-danger"
                    text="Eliminar"
                    @click="deleteManualAdd(detail)"
                  />
                  <action-button
                    v-if="detail.excludeFlag && !detail.isManualAddFlag"
                    i="fas fa-plus-circle"
                    variant="outline-success"
                    text="Incluir"
                    @click="includeStudent(detail)"
                  />
                  <action-button
                    v-if="!detail.excludeFlag && !detail.isManualAddFlag"
                    i="fas fa-minus-circle"
                    variant="outline-success"
                    text="Excluir"
                    @click="showExcludePanel(detail)"
                  />
                </div>
              </div>
            </div>
          </div>

          <template #container_bottom>
            <div class="row">
              <div v-if="detail.excludeReasonId != 1" class="col-md-12">
                <span class="body-2 text-gray">Razón:</span>
                <p class="body-1 font-weight-normal">
                  {{ detail.excludeReasonName }}
                </p>
              </div>
              <div v-if="detail.excludeReasonId == 1" class="col-md-3">
                <span class="body-2 text-gray">Razón:</span>
                <p class="body-1 font-weight-normal">
                  {{ detail.excludeReasonName }}
                </p>
              </div>
              <div v-if="detail.excludeReasonId == 1" class="col-md-9">
                <span class="body-2 text-gray">Comentario:</span>
                <p class="body-1 font-weight-normal">
                  {{ detail.excludeReasonOther }}
                </p>
              </div>
            </div>
          </template>

          <template #edition>
            <div class="w-100 p-3">
              <div class="w-100">
                <em
                  class="fas fa-minus-circle rounded-circle shadow text-orange p-1"
                />
                <span class="ml-2">Razón para Excluir</span>
              </div>
              <validation-observer ref="excludeValidator">
                <div class="row mt-3">
                  <div class="col-12">
                    <validation-provider
                      v-slot="{ errors }"
                      class="mr-5 gap"
                      rules="required"
                    >
                      <custom-drop-down
                        v-model="selectedExcludeReason"
                        label="Razón:"
                        :error="errors[0]"
                        :custom-error-msg="messages['0675']"
                        placeholder="Seleccionar"
                        :options="studentExcludeReasons"
                        fieldkey="id"
                        fieldname="name"
                      />
                    </validation-provider>
                  </div>
                  <div class="clearfix" />
                  <div class="col-12">
                    <validation-provider
                      v-if="IsCommentVisible"
                      v-slot="{ errors }"
                      class="flex-grow-2"
                      rules="required"
                    >
                      <div>
                        <label class="input-label">Comentario:</label>
                        <custom-text-area
                          v-model="excludeReasonComment"
                          :show-char-count="true"
                          :error="errors[0]"
                          :custom-error-msg="messages['0675']"
                          :maxlength="commentMaxSize"
                          type="text"
                        />
                      </div>
                    </validation-provider>
                  </div>
                </div>
              </validation-observer>
              <div class="d-flex justify-content-end mt-4">
                <action-button
                  variant="danger mr-2"
                  i="fas fa-times-circle"
                  text="Cancelar"
                  @click="cancelEdit(detail)"
                />
                <action-button
                  variant="success"
                  text="Continuar"
                  @click="excludeStudent(detail)"
                />
              </div>
            </div>
          </template>
        </custom-callout>
        <div
          v-if="detail.studentHasCertificationForAnotherSchool"
          class="alert alert-warning"
          role="alert"
        >
          <div class="alert-content">
            <i class="fas mr-2 fa-bell-exclamation" />
            <span
              >Este estudiante se encuentra certificado en la siguiente escuela
              {{ detail.studentCertificationForAnotherSchoolName }}</span
            >
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import PageHeader from "@/components/common/page/PageHeader";
import Board from "@/views/student/quotes/components/Board";
import alert from "@/mixin/alert.mixin";
import FilterManager from "FilterManager";
import { SectionTitle } from "@/components/pei/shared";
import ResourcesService from "@/services/resources.js";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import CustomTextArea from "@/components/common/CustomTextArea";
import childCountService from "@/services/api/childCount.api";
import statusColorMixin from "@/components/student/registry/statusColor.js";

import ChildCountExcludeReasons from "@/utils/constants/student/childCountExcludeReasons";
import ChildCountStatus from "@/utils/constants/student/childCountStatusEnum";
import schoolTypes from "@/utils/constants/student/schoolTypes.js";
import {
  ActionButton,
  CustomSeparator,
  CustomCallout,
  CustomBalloonLight as CustomBalloon,
  CustomDropDown,
  CustomInput
} from "@/components/common";

const _StudentInCertificationPanel = 0;

export default {
  name: "InformationCertification",
  mixins: [alert, statusColorMixin],
  components: {
    PageHeader,
    Board,
    ActionButton,
    FilterManager,
    CustomSeparator,
    CustomCallout,
    CustomBalloon,
    CustomDropDown,
    CustomInput,
    SectionTitle,
    ValidationProvider,
    ValidationObserver,
    CustomTextArea
  },
  data() {
    return {
      page: {
        icon: "fas fa-user-circle",
        title: "Certificación de Matrícula",
        routes: ["Inicio", "Estudiante", "Certificación de Matrí­cula"]
      },
      // Se agrego este flag en caso de querer volver a mostrar el student header en el futuro.
      showStudentHeader: false,
      certificationData: {
        academicYearDescription: null,
        academicYearId: null,
        certificationNumber: null,
        childCountCertificationId: null,
        districtId: null,
        districtName: null,
        locationSchoolId: null,
        municipalityId: null,
        municipalityName: null,
        regionId: null,
        regionName: null,
        schoolCdName: null,
        schoolCode: null,
        schoolName: null,
        statusCertificationDenyReasonComment: null,
        statusCertificationId: null,
        statusCertificationName: null,
        totalStudentExcluded: null,
        totalStudentManualAdd: null,
        totalStudentSIE: null
      },
      selectedExcludeRecordId: null,
      selectedExcludeReason: null,
      excludeReasonComment: null,
      studentCertificationData: [],
      custodianGroup: [],
      separatorFilter: {
        options: [
          {
            id: 0,
            name: "Estudiantes en Certificación",
            active: true,
            value: 0
          },
          {
            id: 2,
            name: "Estudiantes Excluidos",
            value: 2
          }
        ]
      },
      filterCollections: {
        alertOptions: [
          {
            id: 1,
            name: "Estudiantes en otra escuela",
            value: 1
          }
        ]
      },
      childCountCertificationId: null,
      searchMode: 0,
      commentMaxSize: 500,
      studentInfoManual: {
        visible: false,
        isValid: null,
        data: null,
        studentSie: ""
      },
      catalog: {
        custodianList: []
      },
      selectedCustodian: null,
      isPrivateSchool: false
    };
  },
  async mounted() {
    const paramsFromRoute = this.$root.$route.params;
    this.childCountCertificationId = paramsFromRoute.childCountCertificationId;

    await this.loadCertification(this.childCountCertificationId).then(() => {
      if (
        this.certificationData.statusCertificationId ==
          ChildCountStatus.approved ||
        this.certificationData.statusCertificationId ==
          ChildCountStatus.submited
      ) {
        this.hideStudentWhioutCustodian();
      }
    });
    await this.loadStudentExcludeReasons();
    //StudentFilters load the certifications data inside
    await this.setStudentFilter(0); //Students in certification

    this.messages = await ResourcesService.LoadValidationMessages(["0675"]);
  },
  methods: {
    async loadCertification(certificationId) {
      await childCountService
        .loadCertification(certificationId)
        .then(response => {
          this.certificationData = response.data;

          this.isPrivateSchool =
            this.certificationData.schoolTypeId != schoolTypes.PublicSchool;
        });
    },
    async loadStudentCertification(certificationId, filters = {}) {
      await childCountService
        .loadStudentCertification(
          certificationId,
          this.isPrivateSchool,
          this.searchMode,
          filters
        )
        .then(response => {
          this.studentCertificationData = response.data;
          this.certificationData.totalStudentSIE = response.data.length;
          const custodians = [];
          //set current custodian
          this.studentCertificationData = this.studentCertificationData.map(
            item => {
              if (
                item.custodianUserFullName &&
                (item.custodianUserId || item.alternativeLocationTeacherId)
              ) {
                custodians.push({
                  name: item.custodianUserFullName,
                  id: item.custodianUserId || item.alternativeLocationTeacherId
                });
              }

              if (item.custodianUserFullName && item.custodianUserId) {
                item.selectedCustodian = {
                  id: item.custodianUserId,
                  name: item.custodianUserFullName
                };
              }
              return item;
            }
          );

          const grouped = this.groupBy(
            this.studentCertificationData,
            "custodianUserFullName"
          );

          this.custodianGroup = this.sortSingleObject(grouped);

          if (this.catalog.custodianList.length == 0) {
            const custodiansResult = [];
            const map = new Map();
            for (const item of custodians) {
              if (!map.has(item.id)) {
                map.set(item.id, true); // set any value to Map
                custodiansResult.push({
                  id: item.id,
                  name: item.name
                });
              }
            }
            this.catalog.custodianList = custodiansResult;
          }
        });
    },
    async loadStudentExcludeReasons() {
      await childCountService.loadStudentExcludeReasons().then(response => {
        this.studentExcludeReasons = response.data;
      });
    },
    showExcludePanel(record) {
      if (this.selectedExcludeRecordId != null) {
        let oldRecord = this.studentCertificationData.find(
          x =>
            x.childCountCertificationStudentId === this.selectedExcludeRecordId
        );

        oldRecord.showEdit = false;
      }

      this.selectedExcludeRecordId = record.childCountCertificationStudentId;

      if (record.showEdit == undefined) record.showEdit = false;

      record.showEdit = !record.showEdit;

      this.selectedExcludeReason = null;
      this.excludeReasonComment = null;

      this.$forceUpdate();
    },
    async excludeStudent(record) {
      const isValid = await this.$refs.excludeValidator[0].validate();
      if (!isValid) {
        this.ShowToast(
          "Error",
          "Favor verificar y completar la información solicitada. ",
          this.toastType.Error
        );
        return;
      }

      this.$refs.excludeValidator[0].reset();
      await this.$ApiPost("/api/childcount/exclude", {
        childCountStudentCertificationId:
          record.childCountCertificationStudentId,
        reasonId: this.selectedExcludeReason.id,
        comment: this.excludeReasonComment
      })
        .then(async () => {
          this.ShowToast(
            "Completado",
            "Su información ha sido completada exitosamente.",
            this.toastType.Success
          );

          await this.loadStudentCertification(this.childCountCertificationId);
          await this.loadCertification(this.childCountCertificationId);

          this.selectedExcludeRecordId = null;
          this.selectedExcludeReason = null;
          this.excludeReasonComment = null;
        })
        .catch(err => {
          this.ShowToast("Error", err.response.data.message, "error");
        });
    },
    cancelEdit(record) {
      record.showEdit = !record.showEdit;

      this.$forceUpdate();
    },
    async submitCertification() {
      if (
        this.studentCertificationData.some(
          c => c.studentHasCertificationForAnotherSchool
        )
      ) {
        await this.ShowToast(
          "Error",
          "No es posible someter, ya que cuenta con estudiantes certificados en otra escuela.",
          this.toastType.Error
        );
        return;
      }

      const answerResult = await this.ShowCancelModal(
        "Aviso",
        "¿Está seguro que desea certificar la matricula?",
        "Sí",
        "No"
      );

      if (answerResult) {
        await childCountService
          .submitCertification(this.childCountCertificationId)
          .then(() => {
            this.ShowToast(
              "Proceso Exitoso",
              "Certificación sometida exitosamente.",
              this.toastType.Success
            );

            this.certificationData.statusCertificationId =
              ChildCountStatus.submited;
            this.certificationData.statusCertificationName = "Sometido";
            this.hideStudentWhioutCustodian();
          })
          .catch(err => {
            this.ShowToast("Error", err.response.data.message, "error");
          });
      }
    },
    groupBy(array, key) {
      const result = {};
      array.forEach(item => {
        if (!result[item[key]]) {
          result[item[key]] = [];
        }
        result[item[key]].push(item);
      });
      return result;
    },
    async setStudentFilter(value) {
      this.separatorFilter.options.forEach(element => {
        element.active = false;
      });

      this.separatorFilter.options[value].active = true;

      await this.onStudentFilterChanged(value);
    },
    async onStudentFilterChanged(value) {
      this.searchMode = value;
      await this.loadStudentCertification(this.childCountCertificationId);
    },
    async fastSearch(filters) {
      await this.loadStudentCertification(this.childCountCertificationId, {
        sie: filters.sie,
        teacher: filters.teacher?.id,
        alertFilterId: filters.alert?.id
      });
    },
    addStudent() {
      this.studentInfoManual.visible = true;
    },
    async searchStudent(studentSieOrRegistry) {
      if (studentSieOrRegistry) {
        const {
          childCountCertificationId,
          academicYearId,
          locationSchoolId
        } = this.certificationData;
        if (childCountCertificationId && academicYearId && locationSchoolId) {
          const { data: response } = await childCountService.searchStudent(
            childCountCertificationId,
            studentSieOrRegistry,
            academicYearId,
            locationSchoolId
          );
          if (response) {
            const { data, isValid, message } = response;
            this.studentInfoManual.isValid = isValid;
            if (!isValid) {
              this.ShowToast("Error", message, this.toastType.Error);
              return;
            } else {
              this.studentInfoManual.data = data;
            }
          }
        }
      }
    },
    async searchAddStudent() {
      const isValid = await this.$refs.searchStudentRef.validate();
      if (isValid) {
        this.searchStudent(this.studentInfoManual.studentSie);
      } else {
        this.ShowToast(
          "Error",
          "Favor de escribir Número de SIE o Registro.",
          this.toastType.Error
        );
      }
    },
    cancelAddStudent() {
      this.studentInfoManual = {
        visible: false,
        data: null,
        studentSie: ""
      };
    },
    async addManualStudent() {
      const { childCountCertificationId } = this.certificationData;
      const { studentId } = this.studentInfoManual.data;
      if (childCountCertificationId && studentId) {
        await childCountService.addStudent(
          childCountCertificationId,
          studentId
        );
        this.ShowToast(
          "Proceso Exitoso",
          "El estudiante fue añadido exitosamente.",
          this.toastType.Success
        );
        this.cancelAddStudent();
        await this.refreshStudentCertification();
      }
    },
    async onChangeCustodian({ childCountCertificationStudentId }, selected) {
      if (childCountCertificationStudentId && selected.id) {
        const response = await childCountService.assignCustodian(
          childCountCertificationStudentId,
          selected.id
        );
        if (response) {
          this.ShowToast(
            "Proceso Exitoso",
            "Estudiante fue incluido en el modo de Estudiantes en Certificación.",
            this.toastType.Success
          );
          await this.refreshStudentCertification();
        }
      }
    },
    async refreshStudentCertification() {
      await this.loadStudentCertification(this.childCountCertificationId);
      await this.loadCertification(this.childCountCertificationId);
    },
    async deleteManualAdd({ childCountCertificationStudentId, studentName }) {
      const answerResult = await this.ShowCancelModal(
        "Aviso",
        `¿Está seguro que desea eliminar el estudiante ${studentName} de la certificación?`,
        "Sí",
        "No"
      );
      if (answerResult) {
        const response = await childCountService
          .removeManualStudent(childCountCertificationStudentId)
          .catch(err => {
            this.ShowToast("Error", err.response.data.message, "error");
          });
        if (response) {
          this.ShowToast(
            "Proceso Exitoso",
            "El Estudiante fue elminado correctamente.",
            this.toastType.Success
          );
          await this.refreshStudentCertification();
        }
      }
    },
    async includeStudent({ childCountCertificationStudentId, studentName }) {
      const { academicYearId, locationSchoolId } = this.certificationData;
      if (
        childCountCertificationStudentId &&
        academicYearId &&
        locationSchoolId
      ) {
        const answerResult = await this.ShowCancelModal(
          "Aviso",
          `¿Está seguro que desea incluir el estudiante ${studentName} en la certificación?`,
          "Sí",
          "No"
        );
        if (answerResult) {
          const response = await childCountService
            .include(
              childCountCertificationStudentId,
              academicYearId,
              locationSchoolId
            )
            .catch(err => {
              this.ShowToast("Error", err.response.data.message, "error");
            });

          if (response) {
            this.ShowToast(
              "Proceso Exitoso",
              "El Estudiante fue incluido correctamente.",
              this.toastType.Success
            );
            await this.refreshStudentCertification();
          }
        }
      }
    },
    sortSingleObject(myObj) {
      return Object.entries(myObj)
        .sort()
        .reduce(
          (obj, [k, v]) => ({
            ...obj,
            [k]: v
          }),
          {}
        );
    },
    hideStudentWhioutCustodian() {
      this.separatorFilter = {
        ...this.separatorFilter,
        options: this.separatorFilter.options.filter(x => x.value != 1)
      };
    }
  },
  computed: {
    dashboard() {
      return [
        [
          {
            label: "Año Fiscal:",
            icon: "fas fa-calendar-edit",
            data: this.certificationData.academicYearDescription
          },
          {
            label: "Número Certificación:",
            icon: "fas fa-file-alt",
            data: this.certificationData.certificationNumber
          },
          {
            label: "Estatus:",
            icon: "fas fa-flag",
            data: this.certificationData.statusCertificationName
          },
          {
            label: "Total Incluido:",
            icon: "fas fa-user-friends",
            data: this.certificationData.totalStudentSIE
          },
          {
            label: "Total Manual:",
            icon: "fas fa-user-friends",
            data: this.certificationData.totalStudentManualAdd
          },
          {
            label: "Total Excluido:",
            icon: "fas fa-user-friends",
            data: this.certificationData.totalStudentExcluded
          }
        ]
      ];
    },
    location() {
      return [
        [
          {
            label: "Región:",
            data: this.certificationData.regionName
          },
          {
            label: "Distrito:",
            data: this.certificationData.districtName
          },
          {
            label: "Municipio:",
            data: this.certificationData.municipalityName
          },
          {
            label: "Escuela:",
            data: this.certificationData.schoolCdName
          }
        ]
      ];
    },
    filtersHeader() {
      return [
        {
          name: "sie",
          component: "CustomInput",
          placeholder:
            "Escribir Nombre del Estudiante, Número de SIE o Número de Registro",
          icon: "fa fa-search orange-icon",
          leftIcon: true,
          type: "text",
          class: "col-5 px-0"
        },
        {
          name: "alert",
          label: "Alerta:",
          component: "CustomDropDown",
          class: "col-md-4",
          options: this.filterCollections.alertOptions,
          placeholder: "Seleccione",
          fieldName: "name",
          fieldKey: "id",
          isAdvanced: true
        }
      ];
    },

    IsCommentVisible() {
      return (
        this.selectedExcludeReason != null &&
        this.selectedExcludeReason.id == ChildCountExcludeReasons.Otro
      );
    },
    canBeSubmitted() {
      return (
        this.separatorFilter.options.find(c=> c.active).id == _StudentInCertificationPanel &&
        this.certificationData.statusCertificationId != null &&
        (this.certificationData.statusCertificationId == ChildCountStatus.new ||
          this.certificationData.statusCertificationId ==
            ChildCountStatus.denied)
      );
    },
    IsReadonly() {
      return (
        this.certificationData.statusCertificationId != null &&
        (this.certificationData.statusCertificationId ==
          ChildCountStatus.approved ||
          this.certificationData.statusCertificationId ==
            ChildCountStatus.submited)
      );
    }
  }
};
</script>

<style scoped lang="scss">
.w-balloon {
  width: 25%;
}

.ml-6 {
  margin-left: 4rem !important;
}

.w-balloon-status {
  width: 100px;
}

.student-info-container {
  &__box-main-title {
    text-align: left;
    font: Bold 18px/22px Lato;
    letter-spacing: 0px;
    color: #11291b;
    margin-top: 10px;
  }
  &__field-label {
    text-align: left;
    font: Regular 14px/28px Lato;
    color: #727272;
  }
  &__field-value {
    text-align: left;
    font: Regular 16px/28px Lato;
    color: #11291b;
  }
}

@media screen and (max-width: 768px) {
  .w-balloon {
    display: none !important;
  }
}

@media screen and (max-width: 411px) {
  .w-balloon {
    display: none !important;
    margin-top: 5%;
    width: 50% !important;
  }

  .actions-add {
    margin-top: 2%;
    margin-right: 1% !important;
  }
}

.alert-content {
  color: #af6708;
}

</style>
